import {newInitializeSelectRentObjectScreen, newSelectRentObject} from "../../shared/actions.js";

export const initialize = newInitializeSelectRentObjectScreen({reservationPath: "B2C", isLtr: true});

export const selectRentObject = newSelectRentObject({reservationPath: "B2C", isLtr: true});
